export default __webpack_public_path__ + "static/media/gear-gray.87a242f2.png";